// @ts-check
import * as React from "react";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import MyAlert from "../../controls/MyAlert";
import {
  enumData,
  enumLocalStorageArgs,
  enumPage,
  enumPagination,
  enumRoutes,
  enumSharedMsgs,
  enumSQLS,
} from "../../helpers/common.constants";
import Button from "@mui/material/Button";
import {
  Card,
  CardContent,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Box,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import MyDropDown from "../../controls/MyDropDown";
import { MessageHelper } from "../../helpers/MessageHelper";
import FinTimeActions from "../../actions/FinTimeActions";
import moment from "moment";
import MyAutoSuggestMulti from "../../controls/MyAutoSuggestMulti";
import DownloadActions from "../../actions/DownloadActions";
import LocalStorageHelper from "../../helpers/LocalStorageHelper";
import '../../helpers/common.function';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CurrencyHelper from "../../helpers/CurrencyHelper";
import MyDialogYesNo from "../../controls/MyDialogYesNo";

const RecordDefault = {
  
};

export default function FinTimeRecreationSearch() {
  const [Record, setRecord] = useState(RecordDefault);
  const [MessageData, setMessageData] = useState({});
  const [RecordTimesheetCreate, setRecordTimesheetCreate] = useState(RecordDefault);
  const [RecordTimesheetDelete, setRecordTimesheetDelete] = useState(RecordDefault);
  const [Records, setRecords] = useState([]);
  const [IsInitDone, setIsInitDone] = useState(false);
  const [IsModalOpen, setIsModalOpen] = useState(false);
  const [IsModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const [ModalMsg, setModalMsg] = useState('');

  //Za Refreshiranje na strana mu treba;
  const location = useLocation();

  //za poraki pri loadiranje na strana
  const msgHelper = new MessageHelper();

  //****************************************** */
  //HOOKS SECTION HERE
  //****************************************** */

  //1 --> Ke se povika ovoj HOOK samo dokolku se SMENI url-ot poradi toa na new dodavame Ticks() za da forcirame refresh na strana na sekoj click
  useEffect(() => {
    initData();
  }, [location.pathname + "/" + location.search]);

  //2 --> Od koga e sredena InitData() povikaj Search  (https://stackoverflow.com/questions/54069253/the-usestate-set-method-is-not-reflecting-a-change-immediately)
  useEffect(() => {
    if (IsInitDone) {
      searchData();
    }
  }, [IsInitDone]);

  //****************************************** */
  //METHOD  SECTION HERE
  //****************************************** */

  const initData = () => {
    async function fetchData() {
      //Clean all states
      setIsInitDone(false);
      setRecord(RecordDefault);

      //Proveri dali slucajno ima vo Local Storage definirani Search Arguments
      let RecordFromStorage = new LocalStorageHelper().GetJSON(enumLocalStorageArgs.FinTimeEntrySearch);
      if (RecordFromStorage) {
        RecordDefault.PageIndex = 0;
        RecordDefault.StaffIDs = RecordFromStorage.StaffIDs;
        RecordDefault.Month = RecordFromStorage.Month;
        RecordDefault.ProjectIDs = RecordFromStorage.ProjectIDs;
        RecordDefault.Year = RecordFromStorage.Year;
        setRecord(RecordDefault);
      }

      //Load Start
      let result = msgHelper.setPhase(enumPage.LoadStart);
      setMessageData(result);

      setIsInitDone(true);

      //Load Finished
      result = msgHelper.setPhase(enumPage.LoadSuccess);
      setMessageData(result);
    }
    fetchData();
  };

  const searchData = () => {
    async function fetchData() {
      //Load Start
      setRecords([]);
      let result = msgHelper.setPhase(enumPage.LoadStart);
      setMessageData(result);

      let responses = await new FinTimeActions().RecreationSearchAsync(Record);
      if (!responses.error) {
        const records = responses[0].data;

        setRecords(records);

        //Load Finished
        result = msgHelper.setPhase(enumPage.LoadSuccess);
        setMessageData(result);
      } else {
        //Load with Error
        result = msgHelper.setPhase(enumPage.ErrorServer, responses);
        setMessageData(result);
      }
    }
    fetchData();
  };

  const handleCloseModalForTimesheetCreate = (isOk) => {

    setIsModalOpen(false);

    if (!isOk) return;

    async function fetchData() {
      //Load Start
      setRecords([]);
      let result = msgHelper.setPhase(enumPage.LoadStart);
      setMessageData(result);

      let payload = {ftsStaffID : RecordTimesheetCreate.facStaffID,  
                    ftsMonth : RecordTimesheetCreate.facMonth,  
                    ftsYear : RecordTimesheetCreate.facYear,   
                    RewriteTimesheet : true,
                    ftsStaffName : RecordTimesheetCreate.facStaffName,
                    ftsStaffEmail : RecordTimesheetCreate.facStaffEmail}
      
      let responses = await new FinTimeActions().RecreateAsync(payload);
      if (!responses.error) {
        const records = responses[0].data;

        setRecords(records);

        //Load Finished
        result = msgHelper.setPhase(enumPage.LoadSuccessWithMsg, null, "Timesheet created successfully.");
        setMessageData(result);

        await searchData();
        
      } else {
        //Load with Error
        result = msgHelper.setPhase(enumPage.ErrorServer, responses);
        setMessageData(result);
      }
    }
    fetchData();
  };


  const handleCloseModalForTimesheetDelete = (isOk) => {

    setIsModalOpenDelete(false);

    if (!isOk) return;

    async function fetchData() {
      //Load Start
      setRecords([]);
      let result = msgHelper.setPhase(enumPage.LoadStart);
      setMessageData(result);

      let payload = {ftsStaffID : RecordTimesheetDelete.facStaffID,  
                    ftsMonth : RecordTimesheetDelete.facMonth,  
                    ftsYear : RecordTimesheetDelete.facYear,
                    ftsStaffName : RecordTimesheetDelete.facStaffName,
                    ftsStaffEmail : RecordTimesheetDelete.facStaffEmail}
      
      let responses = await new FinTimeActions().DeleteAsync(payload);
      if (!responses.error) {
        const records = responses[0].data;

        setRecords(records);

        //Load Finished
        result = msgHelper.setPhase(enumPage.LoadSuccessWithMsg, null, "Timesheet deleted successfully.");
        setMessageData(result);

        await searchData();
        
      } else {
        //Load with Error
        result = msgHelper.setPhase(enumPage.ErrorServer, responses);
        setMessageData(result);
      }
    }
    fetchData();
  };

  
  const handleAllTimesheetData = () => {

    async function fetchData() {
      //Load Start
      setRecords([]);
      let result = msgHelper.setPhase(enumPage.LoadStart);
      setMessageData(result);
      
      let responses = await new FinTimeActions().RecreateAllAsync();
      if (!responses.error) {
        const records = responses[0].data;

        setRecords(records);

        //Load Finished
        result = msgHelper.setPhase(enumPage.LoadSuccessWithMsg, null, "All done.");
        setMessageData(result);

        await searchData();
        
      } else {
        //Load with Error
        result = msgHelper.setPhase(enumPage.ErrorServer, responses);
        setMessageData(result);
      }
    }
    fetchData();
  };

  //****************************************** */
  //HANDLERS SECTION HERE
  //****************************************** */
  
  const handleOpenModalForTimesheetCreate = (record) => { //Povikuva onDelete(record);
    setRecordTimesheetCreate(record);
    setModalMsg("Are you sure you want to recreate timesheet for  " +
               record.facStaffName + 
               " for period:" + 
               record.facMonth.toString().ToMonthName() + "/" + record.facYear)
    setIsModalOpen(true); //Otvori popup
  };

  const handleOpenModalForTimesheetDelete = (record) => { //Povikuva onDelete(record);
    setRecordTimesheetDelete(record);
    setModalMsg("Are you sure you want to delete timesheet for  " +
               record.facStaffName + 
               " for period:" + 
               record.facMonth.toString().ToMonthName() + "/" + record.facYear)
    setIsModalOpenDelete(true); //Otvori popup
  };

  return (
    <Typography sx={{ my: 5, mx: 2 }} color="text.secondary" align="left">
      <MyAlert {...MessageData} />

      <RenderTable Records={Records} MessageData={MessageData} 
          onCreateTimesheet={handleOpenModalForTimesheetCreate}
          onDeleteTimesheet={handleOpenModalForTimesheetDelete}
          onCreateDeleteAllAtOnceTimesheet={handleAllTimesheetData} />

      <MyDialogYesNo IsOpen={IsModalOpen} HandleModalClose={handleCloseModalForTimesheetCreate} Title={enumSharedMsgs.WariningMsg} 
            Content={ModalMsg} />

      <MyDialogYesNo IsOpen={IsModalOpenDelete} HandleModalClose={handleCloseModalForTimesheetDelete} Title={enumSharedMsgs.WariningMsg} 
            Content={ModalMsg} />            
    </Typography>
  );
}

const RenderTable = ({ Records, MessageData, onCreateTimesheet, onDeleteTimesheet, onCreateDeleteAllAtOnceTimesheet }) => {
  const navigate = useNavigate();

  return React.useMemo(() => {
    return (
      <TableContainer
        sx={{ display: { xs: "block", sm: "block", md: "block" } }}
      >
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography variant="h4" align="center">
                  Employee
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" align="center">
                  Contract Period
                </Typography>
              </TableCell>              
              <TableCell>
                <Typography variant="h4" align="center">
                  Month/Year
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" align="center">
                  Contract Days 
                </Typography>
              </TableCell>                     
              <TableCell>
                <Typography variant="h4" align="center">
                  Allocate Days
                </Typography>
              </TableCell>
              <TableCell>
                  <Button
                      variant="contained"
                      color="success"
                      size="medium"
                      disabled={MessageData.Loading}
                      onClick={() => onCreateDeleteAllAtOnceTimesheet()}
                      sx={{ mr: 1 }} // Adjust margin to the right of the Search button
                    >
                      Run all at once
                    </Button>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Records.map((row, index) => (
              <TableRow
                key={row.rqRequestID}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell>
                  {index + 1}. {row.facStaffName}
                </TableCell>

                <TableCell>
                  {moment(row.StaffContractStart).format("DD/MM/YYYY")}  - {moment(row.StaffContractEnd).format("DD/MM/YYYY")}
                </TableCell>

                <TableCell align="left">
                  {row.facMonth.toString().ToMonthName()} / {row.facYear}<br/>
                </TableCell>

                <TableCell>
                  {new CurrencyHelper().ToMoneyFormatDigits(row.DaysPerMonth, 1)}
                </TableCell>

                <TableCell align="right">
                  {new CurrencyHelper().ToMoneyFormatDigits(row.MonthPlannedDays, 1)}
                  
                </TableCell>


                <TableCell align="left">

                    {row.MonthPlannedDays > 0 && 
                    <Button
                      variant="contained"
                      color="success"
                      size="medium"
                      disabled={MessageData.Loading}
                      onClick={() => onCreateTimesheet(row)}
                      sx={{ mr: 1 }} // Adjust margin to the right of the Search button
                    >
                      Recreate Timesheet for {row.facMonth.toString().ToMonthName()} / {row.facYear}
                    </Button>
                    }

                    {row.MonthPlannedDays == 0 && 
                    <Button
                      variant="contained"
                      color="error"
                      size="medium"
                      disabled={MessageData.Loading}
                      onClick={() => onDeleteTimesheet(row)}
                      sx={{ mr: 1 }} // Adjust margin to the right of the Search button
                    >
                      Delete Timesheet for {row.facMonth.toString().ToMonthName()} / {row.facYear}
                    </Button>
                    }

                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }, [Records, MessageData]);
};
